import * as React from "react"
import {Box} from "@mui/material";
import {ButtonLoadingSeeker, ButtonSeeker, PopoverSeeker, PopoverSeekerItem} from "@ui-seeker/core";
import {useSignal} from "@preact/signals-react";

import {useToast} from "@hooks";
import {disabledCommonFiltersSubmit, isLoadingCommonFilters, isSystemBusy, resetCommonFilters, submittedFilters} from "@signals";


export default function CommonFiltersFooter({downloadCSV, showReset=true, downloadCSVOptions=null }) {
	const { showToast } = useToast()
	const isDownloadingExcel = useSignal(false)
	const csvPopoverAnchor = useSignal(null)

	const handleDownload = async (extraData = {}) => {
		csvPopoverAnchor.value = null
		isDownloadingExcel.value = true
		try {
			await showToast.promiseExcel(
				downloadCSV,
				{ limitResults: false, ...extraData },
				null,
				{ pending: 'Downloading CSV (This may take a few minutes).' }
			)
		} finally {
			isDownloadingExcel.value = false
		}
	}

	return <Box sx={{ display: 'flex' }}>
		{ !!showReset && <ButtonSeeker
			variant="outlined"
            sx={{ mx: 2 }}
			onClick={() => resetCommonFilters()}
		>
			Reset Search
		</ButtonSeeker> }

		<ButtonLoadingSeeker
			disabled={disabledCommonFiltersSubmit.value}
			loading={isLoadingCommonFilters.value}
			onClick={() => {
				submittedFilters.value = {}
				isSystemBusy.value = false
				setTimeout(() => isLoadingCommonFilters.value = true, 200)
			}}
			sx={{ mr: 2 }}
		>
			Search
		</ButtonLoadingSeeker>

		{ !!downloadCSV && <>
			<ButtonLoadingSeeker
				disabled={isDownloadingExcel.value}
				loading={isDownloadingExcel.value}
				sx={{ backgroundColor: 'success.lighter' }}
				onClick={downloadCSVOptions
					? e => { csvPopoverAnchor.value = e.currentTarget }
					: () => handleDownload()
				}
			>
				Download CSV
			</ButtonLoadingSeeker>

			{ !!downloadCSVOptions && <PopoverSeeker
				anchorEl={csvPopoverAnchor.value}
				onClose={() => csvPopoverAnchor.value = null}
			>
				{ downloadCSVOptions.map(({ label, icon = 'cloud-arrow-down', extraData = {} }) => (
					<PopoverSeekerItem
						key={label}
						icon={icon}
						label={label}
						onClick={() => handleDownload(extraData)}
					/>
				)) }
			</PopoverSeeker> }
		</> }
	</Box>
}